import React, { useState } from "react";
import "./FormFieldsStyle.css";
import { Select } from "antd";

const Dropdown = (props) => {
  const dataList = props.item && props.item.text_data;
  const [open, setOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]); 

  const handleChange = (selectedValues, op) => {
  
    if (selectedValues.length <= 3) {
      setSelectedItems(selectedValues);

    
      if (selectedValues.length > 0) {
        props?.inputValue?.current?.removeAttribute("disabled");
      } else {
        props?.inputValue?.current?.setAttribute("disabled", true);
      }

      
      const commaSeparatedValues = selectedValues.join(", ");
      localStorage.setItem(
        "inputValue",
        JSON.stringify({ key1: commaSeparatedValues })
      );
    }
  };

  const handleOpenChange = (open) => {
    setOpen(open);
  };

  const Options = dataList?.data?.map((item) => (
    <Select.Option key={item.value} value={item.value}>
      {item.name}
    </Select.Option>
  ));

  return (
    <div
      className="form-group action-tab"
      style={{ width: "90%", marginLeft: "7px" }}
    >
      <Select
        mode="multiple"
        placeholder="Please select"
        value={selectedItems} 
        onChange={handleChange}
        open={open}
        onDropdownVisibleChange={handleOpenChange}
        style={{ width: "100%" }}
        dropdownClassName="custom-select"
        className="custom-select"
        maxTagCount={3} 
      >
        {Options}
      </Select>
      <span className="validate">&nbsp;</span>
    </div>
  );
};

export default Dropdown;